import React from 'react';
import {CircularProgress, Stack, Typography} from '@mui/material';
import {StyleSx, Sx} from 'app/types/common';
import {DialogClose} from 'app/components/sharedReactComponents/DialogClose/DialogClose';
import {useCloud} from 'app/components/features/cloud';
import {useTeamsQuery} from 'app/components/entities/team';
import {QuickPairing} from 'app/components/widgets/pairing';
import {router} from 'app/router/admin';

const widgetSx: StyleSx = {mt: 14, flex: 1};

interface Props extends Sx {
  code?: string;
}

export function OneClickPairingPage({sx, code}: Props) {
  const {team} = useCloud();
  const teamId = team.id;

  const {data: teams, isSuccess} = useTeamsQuery();

  const renderContent = () => {
    if (!code) {
      router.go('devices');
      return <></>;
    }

    if (!isSuccess) {
      return (
        <Stack flex={1} direction="row" justifyContent="center" alignItems="center" gap={2}>
          <CircularProgress color="secondary" />
          <Typography variant="h5">Preparing teams</Typography>
        </Stack>
      );
    }

    return <QuickPairing sx={widgetSx} code={code} initTeamId={teamId} teams={teams} />;
  };

  return (
    <Stack sx={sx} position="relative" className="container">
      <DialogClose onClose={() => router.go('devices')} />

      {renderContent()}
    </Stack>
  );
}
